
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports",
      function () {
        return require("private-next-pages/airports.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports"])
      });
    }
  